import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { PlanSelector } from '../ui/PlanSelector';
import { ShieldCheck, CreditCard, Clock } from 'lucide-react';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (num: number) => num.toString().padStart(2, '0');
  return <section id="precios" className="py-12 md:py-24 bg-white relative overflow-hidden" data-id="element-179">
      <div className="absolute top-0 inset-x-0 h-2 bg-gradient-to-r from-[#E76F51] via-[#1E2A4A] to-[#8A9A86]" data-id="element-180"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-181">
        {/* Urgency Banner */}
        <motion.div initial={{
        y: -20,
        opacity: 0
      }} whileInView={{
        y: 0,
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-red-50 border border-red-100 rounded-2xl p-4 md:p-6 mb-8 md:mb-12 text-center max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-center gap-3 md:gap-8" data-id="element-182">
          <div className="flex items-center gap-2 text-red-700 font-bold text-sm md:text-base" data-id="element-183">
            <span className="relative flex h-3 w-3" data-id="element-184">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-185"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500" data-id="element-186"></span>
            </span>
            Oferta en vivo
          </div>
          <div className="text-[#1E2A4A] font-medium text-sm md:text-base" data-id="element-187">
            +$10.000 DESPUÉS DEL LANZAMIENTO
          </div>
          <div className="flex items-center gap-2 bg-white px-3 py-1.5 md:px-4 md:py-2 rounded-lg shadow-sm font-mono font-bold text-red-600 text-lg md:text-xl" data-id="element-188">
            <Clock size={18} className="md:w-5 md:h-5" data-id="element-189" />
            {formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:
            {formatTime(timeLeft.seconds)}
          </div>
          <div className="text-xs md:text-sm font-bold text-red-700 uppercase tracking-wide" data-id="element-190">
            Y no vuelve a bajar
          </div>
        </motion.div>

        <div className="text-center mb-6 md:mb-10" data-id="element-191">
          <h2 className="text-3xl md:text-5xl font-extrabold text-[#1E2A4A] mb-2 md:mb-4" data-id="element-192">
            Elegí tu MEGAPACK
          </h2>
          <p className="text-base md:text-xl text-[#1E2A4A]/70 font-medium" data-id="element-193">
            Las dos opciones incluyen los 6 bonos completos
          </p>
        </div>

        <PlanSelector data-id="element-194" />

        <div className="mt-8 md:mt-12 flex flex-wrap justify-center items-center gap-x-4 md:gap-x-6 gap-y-2 md:gap-y-3 text-xs md:text-sm text-[#1E2A4A]/70 font-semibold" data-id="element-195">
          <span className="flex items-center gap-1 md:gap-1.5" data-id="element-196">
            <ShieldCheck size={16} className="text-[#8A9A86] md:w-[18px] md:h-[18px]" data-id="element-197" />{' '}
            Pago seguro
          </span>
          <span className="hidden sm:inline text-gray-300" data-id="element-198">|</span>
          <span className="flex items-center gap-1 md:gap-1.5" data-id="element-199">
            <Clock size={16} className="text-[#8A9A86] md:w-[18px] md:h-[18px]" data-id="element-200" />{' '}
            Acceso en 5 min
          </span>
          <span className="hidden sm:inline text-gray-300" data-id="element-201">|</span>
          <span className="flex items-center gap-1 md:gap-1.5" data-id="element-202">
            <ShieldCheck size={16} className="text-[#8A9A86] md:w-[18px] md:h-[18px]" data-id="element-203" />{' '}
            Garantía 7 días
          </span>
          <span className="hidden sm:inline text-gray-300" data-id="element-204">|</span>
          <span className="flex items-center gap-1 md:gap-1.5" data-id="element-205">
            <CreditCard size={16} className="text-[#8A9A86] md:w-[18px] md:h-[18px]" data-id="element-206" />{' '}
            Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}